export default "__VITE_ASSET__BcQ187JF__"